import { defineFetch } from 'resift';

const makeInitializeEntityFileSync = defineFetch({
  displayName: 'Initialize Entity File Sync',
  make: (entityTypeId: string) => ({
    request: (sourceFileId: string) => ({ http }) =>
      http({
        method: 'POST',
        route: `/entity-types/${entityTypeId}/initialize-sync`,
        data: {
          sourceFile: {
            id: sourceFileId,
          },
        },
      }),
  }),
});

export default makeInitializeEntityFileSync;
